export const JOB_PHASES = {
    UNKNOWN: 'unknown',
    STARTING: 'starting',
    RUNNING: 'running',
    QUEUED: 'queued',
    SCANNING: 'scanning',
    ANALYZING: 'analyzing',
    PLANNING: 'planning',
    RENDERING: 'rendering',
    BUILDING: 'building',
    COMPLETE: 'complete',
    ERROR: 'error',
    CANCELLED: 'cancelled',
    CANCEL_REQUESTED: 'cancel_requested'
};

export const PROGRESS_PHASES = new Set([
    JOB_PHASES.SCANNING,
    JOB_PHASES.ANALYZING,
    JOB_PHASES.PLANNING,
    JOB_PHASES.RENDERING,
    JOB_PHASES.BUILDING
]);

export const BUILD_TOAST_PHASES = new Set([
    JOB_PHASES.PLANNING,
    JOB_PHASES.RENDERING,
    JOB_PHASES.BUILDING
]);

export const TERMINAL_PHASES = new Set([
    JOB_PHASES.COMPLETE,
    JOB_PHASES.ERROR,
    JOB_PHASES.CANCELLED
]);

function _replaceObject(target, next) {
    Object.keys(target).forEach((key) => {
        delete target[key];
    });
    Object.entries(next || {}).forEach(([key, value]) => {
        target[key] = value;
    });
}

function _replaceSet(target, next) {
    target.clear();
    (next || []).forEach((value) => target.add(value));
}

export function applyJobPhasesPolicy(policy = {}) {
    if (!policy || typeof policy !== 'object') return;
    if (policy.job_phases && typeof policy.job_phases === 'object') {
        _replaceObject(JOB_PHASES, policy.job_phases);
    }
    if (Array.isArray(policy.progress_phases)) {
        _replaceSet(PROGRESS_PHASES, policy.progress_phases);
    }
    if (Array.isArray(policy.terminal_phases)) {
        _replaceSet(TERMINAL_PHASES, policy.terminal_phases);
    }
    if (Array.isArray(policy.build_toast_phases)) {
        _replaceSet(BUILD_TOAST_PHASES, policy.build_toast_phases);
    }
}
